var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import parse from 'html-react-parser';
import { Button } from '../../components/CtaButtons';
import './heroWithDiagonalImage.scss';
var HeroWithDiagonalImage = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var data = props.data;
    var ctaButton = (_jsx("a", __assign({ className: "text-enblue-500 h-full w-full", href: (_a = data.cta) === null || _a === void 0 ? void 0 : _a.url }, { children: (_b = data.cta) === null || _b === void 0 ? void 0 : _b.text }), void 0));
    return (_jsxs("div", __assign({ className: "text-white heroWithDiagonalImage-section __" + data.height + " snap-start", style: { backgroundColor: data.color } }, { children: [_jsxs("div", __assign({ className: "heroWithDiagonalImage-content" }, { children: [_jsx("h1", __assign({ className: "heroWithDiagonalImage-heading" }, { children: data.headline }), void 0),
                    data.body && (_jsx("div", __assign({ className: "heroWithDiagonalImage-copy" }, { children: parse(data.body) }), void 0)),
                    ((_c = data.cta) === null || _c === void 0 ? void 0 : _c.url) && ((_d = data.cta) === null || _d === void 0 ? void 0 : _d.text) && (_jsx(Button, __assign({ classes: [
                            'text-enblue-500',
                            'focus:bg-enblue-light',
                            'ArticleButtons_custom',
                            'heroWithDiagonalImage-cta',
                        ], animate: "animate-white" }, { children: ctaButton }), void 0))] }), void 0),
            _jsx("div", __assign({ className: "heroWithDiagonalImage-image __" + data.height }, { children: _jsx("div", __assign({ className: "heroWithDiagonalImage-image__wrapper" }, { children: _jsx("img", { src: (_e = data.image) === null || _e === void 0 ? void 0 : _e.src, alt: (_f = data.image) === null || _f === void 0 ? void 0 : _f.alt }, void 0) }), void 0) }), void 0)] }), void 0));
};
export default HeroWithDiagonalImage;
